import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_DASHBOARDS } from "./actionTypes";

import { setDashboards, apiError } from "./actions";

import axios from "axios";

import { integerBetween } from "../../Libs/CustomMethods/customMethods";
import { getErrorMessage } from "../../Libs/SagaUtils/sagaUtils";

function* getDashboards({ payload: { target } }) {
  try {
    const response = yield call(axios.get, `/${target}`);
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.data) {
      yield put(setDashboards(target, data.data.index));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}

export function* watchDashboard() {
  yield takeEvery(GET_DASHBOARDS, getDashboards);
}

function* authSaga() {
  yield all([fork(watchDashboard)]);
}

export default authSaga;
